/**
 * Classe de códigos de domínios do sistema
 *
 * @class Dominios
 */
export default class Dominios {
    static CODIGO_VOTO_CONVERGENTE = 1;
    static CODIGO_VOTO_DIVERGENTE = 2;
    static CODIGO_VOTO_RESSALVA = 3;
    static CODIGO_VOTO_CONVERGENTE_TACITO = 4;
    static TIPO_OBSERVACAO_VOTO_RESSALVA = 2;
    static TIPO_OBSERVACAO_VOTO_DESTAQUE = 4;
    static TIPO_OBSERVACAO_VOTO_DIVERGENCIA = 5;
    static TIPO_OBSERVACAO_VOTO_MINUTA_RETORNO_VISTA = 6;
}
